import React from "react";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";

Bugsnag.start({
  apiKey: window.HA_CONF.BUGSNAG.API_KEY,
  plugins: [new BugsnagPluginReact()],
  releaseStage: `${window.HA_CONF.ENV}-js`,
  enabledReleaseStages: ["production-js", "test-js", "staging-js"],
});

export const BugsnagErrorBoundary =
  Bugsnag.getPlugin("react").createErrorBoundary(React);
